import React from 'react';
import ContextIsolator from '../_util/ContextIsolator';
function usePopupRender(renderFn) {
    return React.useMemo(() => {
        if (!renderFn) {
            return undefined;
        }
        return (...args) => React.createElement(ContextIsolator, { space: true }, renderFn(...args));
    }, [renderFn]);
}
export default usePopupRender;
